import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Stack, Container, Typography, Card } from '@mui/material';
import Page from '../../components/Page';
import Email from './Email';
import Otp from './Opt';
import Password from './Password';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));
export interface Values {
  id: string;
  email: string;
  otp: string;
  password: string;
  confirmPassword: string;
}

const Index: React.FC = () => {
  const [steps, setSteps] = useState(1);
  const [values, setValues] = useState({
    id: '',
    email: '',
    otp: '',
    password: '',
    confirmPassword: '',
  });

  const renderForm = (steps: number) => {
    switch (steps) {
      case 1:
        return (
          <Email
            setSteps={setSteps}
            state={values}
            setValues={setValues}
          />
        );
      case 2:
        return (
          <Otp
            setSteps={setSteps}
            state={values}
            setValues={setValues}
          />
        );
      case 3:
        return (
          <Password
            setSteps={setSteps}
            state={values}
            setValues={setValues}
          />
        );
      default:
        break;
    }
  };
  return (
    <RootStyle title='Reset Password'>
      <Container maxWidth='sm'>
        <ContentStyle>
          <Card
            sx={{
              p: { xs: '50px 20px 50px 20px', sm: '50px 30px 50px 30px' },
              boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
            }}
          >
            <Stack sx={{ mb: 2 }}>
              <Typography
                variant='h4'
                gutterBottom
              >
                Reset your password.
              </Typography>
            </Stack>
            {renderForm(steps)}
          </Card>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
};
export default Index;
